module.exports = __webpack_public_path__ + "img/slide_3.a1700cf8.jpg";